import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

// Sizes pictures for screens 390px
import PictureSecure390px from "../../../../imgs/AboutUsPictures/390px/secure-edited.jpg";
import PictureEasy390px from "../../../../imgs/AboutUsPictures/390px/easy-to-use-edited.png";
import PictureLanguages390px from "../../../../imgs/AboutUsPictures/390px/multiple-languages-edited.jpg";
// Sizes pictures for screens 428px
import PictureSecure428px from "../../../../imgs/AboutUsPictures/428px/secure-edited.jpg";
import PictureEasy428px from "../../../../imgs/AboutUsPictures/428px/easy-to-use-edited.png";
import PictureLanguages428px from "../../../../imgs/AboutUsPictures/428px/multiple-languages-edited.jpg";
// Sizes pictures for screens 744px
import PictureSecure744px from "../../../../imgs/AboutUsPictures/744px/secure-edited.jpg";
import PictureEasy744px from "../../../../imgs/AboutUsPictures/744px/easy-to-use-edited.png";
import PictureLanguages744px from "../../../../imgs/AboutUsPictures/744px/multiple-languages-edited.jpg";
// Sizes pictures for screens 1024px
import PictureSecure1024px from "../../../../imgs/AboutUsPictures/1024px/secure-edited.jpg";
import PictureEasy1024px from "../../../../imgs/AboutUsPictures/1024px/easy-to-use-edited.png";
import PictureLanguages1024px from "../../../../imgs/AboutUsPictures/1024px/multiple-languages-edited.jpg";
// Sizes pictures for screens 1440px
import PictureSecure1440px from "../../../../imgs/AboutUsPictures/1440px/secure-edited.jpg";
import PictureEasy1440px from "../../../../imgs/AboutUsPictures/1440px/easy-to-use-edited.png";
import PictureLanguages1440px from "../../../../imgs/AboutUsPictures/1440px/multiple-languages-edited.jpg";

export const AboutUsSection = styled.main`
  margin-top: 50px;
`;

export const AboutUsTitle = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme?.colors?.publicTitles};

  @media (min-width: 744px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const AboutUsContainer = styled.div`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    padding: 0px;
  }

  @media (min-width: 744px) {
    max-width: 712px;
  }

  @media (min-width: 1024px) {
    max-width: 976px;
  }

  @media (min-width: 1440px) {
    max-width: 1392px;
  }
`;

export const AboutUsList = styled.ul`
  display: flex;
  flex-direction: column;

  margin-top: 78px;

  @media (min-width: 744px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 24px;
    flex-wrap: nowrap;
  }
`;

export const AboutUsListItem = styled.li`
  width: 358px;
  margin-top: 40px;

  &:first-child {
    margin-top: 0px;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;

    &:nth-child(2) {
      margin-top: 0px;
    }
  }

  @media (min-width: 1024px) {
    width: 310px;

    &:nth-child(3) {
      margin-top: 0px;
    }
  }

  @media (min-width: 1440px) {
    width: 448px;
  }
`;

export const AboutUsListCardTitle = styled.h2`
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme?.colors?.publicTitles};

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const AboutUsPictureSecure = styled.div`
  max-width: 100%;
  height: 291px;
  background-image: url(${PictureSecure390px});
  background-size: 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
  margin-top: 30px;
  display: block;

  @media (min-width: 428px) {
    width: 396px;
    height: 322px;
    background-image: url(${PictureSecure428px});
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 283px;
    background-image: url(${PictureSecure744px});
  }

  @media (min-width: 1024px) {
    width: 309px;
    height: 252px;
    background-image: url(${PictureSecure1024px});
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 364px;
    background-image: url(${PictureSecure1440px});
  }
`;

export const AboutUsPictureEasy = styled.div`
  width: 100%;
  height: 316px;
  background-image: url(${PictureEasy390px});
  background-size: 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
  margin-top: 30px;
  display: block;

  @media (min-width: 428px) {
    width: 396px;
    height: 316px;
    background-image: url(${PictureEasy428px});
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 283px;
    background-image: url(${PictureEasy744px});
  }

  @media (min-width: 1024px) {
    width: 310px;
    height: 252px;
    background-image: url(${PictureEasy1024px});
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 364px;
    background-image: url(${PictureEasy1440px});
  }
`;

export const AboutUsPictureLangs = styled.div`
  width: 100%;
  height: 291px;
  background-image: url(${PictureLanguages390px});
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 20px;
  margin-top: 30px;
  display: block;

  @media (min-width: 428px) {
    width: 396px;
    height: 322px;
    background-image: url(${PictureLanguages428px});
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 283px;
    background-image: url(${PictureLanguages744px});
  }

  @media (min-width: 1024px) {
    width: 310px;
    height: 252px;
    background-image: url(${PictureLanguages1024px});
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 364px;
    background-image: url(${PictureLanguages1440px});
  }
`;

export const DescribeContainer = styled.div`
  max-width: 100%;
  padding: 16px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;

  display: flex;
  flex-direction: column;
  gap: 30px;

  margin-top: 50px;

  @media (min-width: 428px) {
    margin-top: 30px;
  }

  @media (min-width: 744px) {
    gap: 50px;
    margin-top: 70px;
  }

  @media (min-width: 1024px) {
    margin-top: 80px;
  }

  @media (min-width: 1440px) {
    width: 1392px;
    gap: 44px;
    margin-top: 65px;
  }
`;

export const DescribeText = styled.p`
  width: 244px;
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme?.colors?.publicTitles};

  @media (min-width: 744px) {
    width: auto;
    font-size: 24px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.18;
  }
`;

export const DescribeButton = styled.button`
  width: 358px;
  background: #1a50c6;
  border-radius: 20px;
  color: #fff;
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  padding: 26px 0px 26px;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme?.colors?.publicDescribeButtonHover};
    transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1440px) {
    width: 448px;
    font-size: 36px;
    font-family: "Exo2 SemiBold";
    line-height: 1.18;
    padding: 17px 0px 17px;
  }
`;
